module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"title":"Padidinta APVA parama įsirengti saulės elektrinę su paskola","side":"Jau galite gauti padidintą APVA paramą saulės elektrinei įsirengti, kuri dabar sudaro net 381 Eur / kW. Parama teikiama saulės elektrinių įsigijimui išsimokėtinai. Prašymus galima teikti iki 2020 m. liepos 1 d.","titleContact":"Susidomėjote? Turite klausimų? Susisiekite!"}}')
  delete Component.options._Ctor
}
